/**
 * 状态使用定义
 * @type {{}}
 */
export const states = {
    0: "废弃",
    1: "正常"
}

/**
 * 财务结算类型
 * @type {{}}
 */
export const settlementTypes = {
    1: "CPS",
    2: "CPA",
    3: "CPC",
    4: "CPM",
    5: "CPT"
}

// 新项目组相关 ios
/**
 * ios 系统类型
 * @type {{}}
 */
export const sysTypes = {
    1: "ios",
    2: "android",
    5: "harmony",
    3: "其他"
}


/**
 * ios 版本更新类型
 * @type {{}}
 */
export const iosUpdateTypes = {
    0: "无",
    1: "普通更新",
    2: "强制更新"
}


/**
 * ios 物品类型
 * @type {{}}
 */
export const goodTypes = {
    0: "可消耗物品",
    1: "其他"
}


/**
 * ios 消耗类型
 * @type {{}}
 */
export const consumeTypes = {
    0: "获取",
    1: "消耗"
}
/**
 * ios 任务类型
 * @type {{}}
 */
export const taskTypes = {
    0: "每日宝箱",
    1: "其他"
}
